import { render, staticRenderFns } from "./infoPoolDetail.vue?vue&type=template&id=382c7d98&scoped=true"
import script from "./infoPoolDetail.vue?vue&type=script&lang=js"
export * from "./infoPoolDetail.vue?vue&type=script&lang=js"
import style0 from "./infoPoolDetail.vue?vue&type=style&index=0&id=382c7d98&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "382c7d98",
  null
  
)

export default component.exports